/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const React = require('react');
const { Pill } = require('@andes/badge');
const Button = require('@andes/button');
const TextField = require('@andes/textfield');
const Dropdown = require('@andes/dropdown');
const Collapse = require('../../../Sidebar/images/Collapse');
const { getEventTracker } = require('../../../../../utils/event-tracker');
const { useApiRefContextProvider } = require('../../../../../providers/apiRefContextProvider');

const { DropdownItem } = Dropdown;

const { useState, useEffect } = React;

const validations = {
  float: new RegExp(/^-?\d+(?:[.,]\d+)?$/),
  number: new RegExp(/^-?\d+(?:[.,]\d+)?$/),
  integer: new RegExp(/^-?\d+$/),
};

const ParamItem = ({ property, i18n, lang, showChilds = false, type, last = false, onUpdate = () => { }, codeType, siteId, setUpdateCodeContentRequestFromParams }) => {
  const Tracker = getEventTracker();
  const collapsableEnum = property?.enum?.length > 3;
  const [collapsedEnum, setCollapsedEnum] = useState(collapsableEnum);
  const [requiredEmpty, setRequiredEmpty] = useState(false);
  const [showChildProps, setShowChildProps] = useState(showChilds);
  const [internalParamValue, setInternalParamValue] = useState(property?.type ? property?.example : property?.schema?.example);

  const { requestParamsData, setRequestParamsData } = useApiRefContextProvider();

  useEffect(() => {
    onUpdate();
  }, [collapsedEnum, internalParamValue, showChildProps]);

  const changeInputValue = (e) => {
    // only allow valid values according to input type
    if (e.target.value && validations[property?.type] && !validations[property?.type].test(e.target.value)) {
      return;
    }

    const newValue = e.target.value;
    const paramsCopy = [...requestParamsData];
    setInternalParamValue(newValue);
    const actualParamValue = paramsCopy.find((param) => param?.name === property?.name);

    if (actualParamValue?.required && !newValue) {
      setRequiredEmpty(true);
    } else setRequiredEmpty(false);


    actualParamValue.example = newValue;
    setRequestParamsData(paramsCopy);
    setUpdateCodeContentRequestFromParams(true);
  };

  const countCharacters = (string) => {
    try {
      return string?.length;
    } catch (error) {
      console.error('An error occurred:', error);
      return 0;
    }
  };

  const collapsableDescription = countCharacters(property?.description?.[lang]) > 220;
  const [collapsedDescription, setCollapsedDescription] = useState(collapsableDescription);

  if (!property.type && !(property.schema && property.schema.type)) {
    return (<></>);
  }

  const isSupportedType = (propertyValue) => {
    const propertyType = propertyValue.type || (propertyValue.schema && propertyValue.schema.type);
    const supportedTypes = ['string', 'number', 'integer', 'float', 'boolean', 'date', 'time'];
    const response = supportedTypes.includes(propertyType);
    return response;
  };

  const toggleChilds = () => {
    setShowChildProps(!showChildProps);

    Tracker.send('mpdevelopers/toggle_content_params_child', showChildProps ? 'hide' : 'show');
  };

  const getDescriptionToDisplay = (collapsed, propDescrip, langDescrip) => {
    if (collapsed) {
      return !propDescrip.enum
        ? propDescrip?.description?.[langDescrip]?.slice(0, 220)
        : propDescrip?.description?.[langDescrip];
    }
    return propDescrip?.description?.[langDescrip];
  };

  const descriptionContent = (
    <>
      {getDescriptionToDisplay(collapsedDescription, property, lang)}
      {property.enum
        && (collapsedEnum ? property.enum.slice(0, 3) : property.enum).map((enumItem) => (
          enumItem.siteId
            ? enumItem.siteId?.includes(siteId) && <div>
              <span className="enum--title">{`${enumItem?.title}: `}</span>
              <span>{`${enumItem?.description?.[lang]}`}</span>
            </div>
            : (<div>
              <span className="enum--title">{`${enumItem?.title}: `}</span>
              <span>{`${enumItem?.description?.[lang]}`}</span>
            </div>)
        ))}
      {(collapsableEnum && collapsedEnum) && <strong onClick={() => setCollapsedEnum(!collapsedEnum)}>{i18n.gettext('Ver más')}</strong>}
      {(!property.enum && collapsableDescription && collapsedDescription) && <strong onClick={() => setCollapsedDescription(!collapsedDescription)}>{`...${i18n.gettext('Ver más')}`}</strong>}
    </>
  );

  const filteredBySiteId = (propertyEnum) => {
    const dropDownItemsFilteredBySiteId = [];

    propertyEnum.map((enumItem) => {
      if (!enumItem.siteId) {
        return dropDownItemsFilteredBySiteId.push(enumItem);
      }
      return enumItem.siteId?.includes(siteId) && dropDownItemsFilteredBySiteId.push(enumItem);
    });

    return dropDownItemsFilteredBySiteId;
  };

  const getInputComponent = () => {
    const propertyType = property.type || (property.schema && property.schema.type);
    if (!isSupportedType(property)) {
      return null;
    }


    if ((['string'].includes(propertyType) && property.enum) && codeType === 'bash') {
      return (
        <Dropdown
          type="form"
          className="dropdown-property"
          defaultValue={property?.example}
          onChange={(e) => {
            changeInputValue(e);
            Tracker.send('mpdevelopers/api-ref/dropdown-param', e.target.value);
          }}
        >
          {
            filteredBySiteId(property.enum).map((enumItem) => (
              <DropdownItem value={enumItem?.title} title={enumItem.title} />
            ))
          }
        </Dropdown>
      );
    }

    if ((['boolean'].includes(propertyType) && codeType === 'bash')) {
      return (
        <Dropdown
          type="form"
          className="dropdown-property"
          placeholder={internalParamValue || i18n.gettext('Insertar valor')}
          defaultValue={property?.example}
          onChange={(e) => {
            changeInputValue(e);
            Tracker.send('mpdevelopers/api-ref/boolean-param', e.target.value);
          }}
        >
          <DropdownItem value="true" title="true" />
          <DropdownItem value="false" title="false" />
        </Dropdown>
      );
    }

    if ((['string', 'number', 'integer', 'float', 'date', 'time'].includes(propertyType) && codeType === 'bash')) {
      return (
        <TextField
          className={`${requiredEmpty ? 'required-empty' : ''}`}
          helper=""
          placeholder={internalParamValue || i18n.gettext('Insertar valor')}
          value={internalParamValue}
          id="textfield-property-value"
          label=""
          onChange={(e) => {
            changeInputValue(e);
            Tracker.send('mpdevelopers/api-ref/textfield-param', e.target.value);
          }}
        />
      );
    }
    return null;
  };

  return (
    <div className={`request-param ${last ? 'last' : ''}`}>
      <div className="request-param--header">
        <div>
          <div className="name-and-infos">
            <span className="name">{property.name}</span>
            <div className="infos">
              <span className="type">{property.type ? property.type : property.schema.type}</span>
              {property.required
                && (
                  <Pill className="required" color="orange" size="small" hierarchy="quiet">
                    {i18n.gettext('Requerido').toUpperCase()}
                  </Pill>
                )}
            </div>
          </div>
          <span className="request-param--description">{descriptionContent}</span>
        </div>
        {type === 'request' && (
          <div className="textfield-property">
            {getInputComponent()}
          </div>
        )}

      </div>


      {property.properties
        && (
          <Button
            className="show-attrs"
            hierarchy="quiet"
            size="small"
            fullWidth={false}
            onClick={toggleChilds}
          >
            <Collapse className={showChildProps ? 'icon__uncollapsed' : 'icon__collapsed'} />
            {i18n.gettext('Mostrar atributos')}
          </Button>
        )}

      {showChildProps && property.properties
        && (
          <div className="child-props">
            {!showChilds
              && (
                <div className="child-props--header">
                  <span className="title">{i18n.gettext('Atributos de {0}', property.name)}</span>
                </div>
              )}
            <div className="child-props--body">
              {property.properties.map((childProp) => (
                <ParamItem
                  i18n={i18n}
                  property={childProp}
                  showChilds
                  type={type}
                  lang={lang}
                  siteId={siteId}
                />
              ))}
            </div>
          </div>
        )}

    </div>
  );
};

module.exports = ParamItem;
